// import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import GreetingSection from '../../components/navbar/GreetingSection';
import { useLocation } from 'react-router-dom';
import { PolicyLocationState } from 'types/life';

import { PolicyDetail } from './components';
const PoliciesDetailPageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;

const PoliciesDetailPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const policies = (location.state as PolicyLocationState) ?? {};
  return (
    <PoliciesDetailPageContainer>
      <GreetingSection pageName={t('life.policies.detailTitle')} showicon={false} />
      <PolicyDetail policy={policies} key={policies.policyNumber}></PolicyDetail>
    </PoliciesDetailPageContainer>
  );
};

export default PoliciesDetailPage;
